import React from 'react'
import PropTypes from 'prop-types'
import ReadItem from './ReadItem'
import { beautifyUrlPath } from '../../../common/utils'

const RecommendedReads = ({ readList }) => {
  const items = readList.length < 3 ? readList : readList.slice(0, 3)

  return (
    <div data-testid="recommended-reads">
      <div className="my-32">
        <div className="mb-2 text-center text-2xl md:text-3xl lg:mb-16 lg:leading-9">
          Recommended Reads
        </div>
        <div className="gap-primary mx-4 grid grid-cols-1 items-start gap-y-0 lg:mx-0 lg:grid-cols-3">
          {items.map((article, key) => (
            <ReadItem
              key={`recommended-${key}`}
              title={article.title}
              category={article.category}
              image={article.image}
              href={beautifyUrlPath(article.path)}
            />
          ))}
        </div>
      </div>
    </div>
  )
}

RecommendedReads.defaultProps = {
  title: 'Recommended Reads',
}
RecommendedReads.propTypes = {
  readList: PropTypes.array.isRequired,
  title: PropTypes.string,
}
export default React.memo(RecommendedReads)
